import IconCopy from "@/icons/IconCopy";
import IconEdit1 from "@/icons/IconEdit1";
import IconTrash from "@/icons/IconTrash";
import Tooltip from "@/components/Tooltip";
import React from "react";

interface Props {
  onEdit(): void;
  onCopy(): void;
  onDelete(): void;
}

export default function ActionBar(props: Props) {
  return (
    <div className="flex flex-row gap-4 items-center w-36 text-slate-400">
      <Tooltip text="Edit" direction="top" minWidth="50px">
        <div
          className="hover:cursor-pointer hover:text-cornflower-blue-500"
          onClick={props.onEdit}
        >
          <IconEdit1 />
        </div>
      </Tooltip>
      <Tooltip text="Copy" direction="top" minWidth="50px">
        <div
          className="hover:cursor-pointer hover:text-cornflower-blue-500"
          onClick={props.onCopy}
        >
          <IconCopy />
        </div>
      </Tooltip>
      <Tooltip text="Delete" direction="top" minWidth="60px">
        <div
          className="hover:cursor-pointer hover:text-cornflower-blue-500"
          onClick={props.onDelete}
        >
          <IconTrash />
        </div>
      </Tooltip>
    </div>
  );
}
